import React, {useContext} from 'react'
import {ButtonGroup, Button} from '@mui/material'
import { DataContext } from '../dataContext'
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    globalblue: {
        main: "#0052cc"
    }, 
    globalred: {
        main: '#e41b23', 
        contrastText: '#fff'
    }
  }
});
export default function YearButtons() {
    const {data, changeYear} = useContext(DataContext)

    return (
        <ThemeProvider theme={theme}>
        <ButtonGroup id="electionyeargroup" className="p-1">
            <Button className={'max-h-8 px-2'} variant={data.currentYear ? "contained" : "outlined"} color="globalred" onClick={()=>changeYear(true)}>{data.config.currentyear}</Button>
            <Button className={'max-h-8 px-2'} variant={!data.currentYear ? "contained" : "outlined"} color="globalred" onClick={()=>changeYear(false)}>{data.config.prevyear}</Button>
        </ButtonGroup>
        </ThemeProvider>
    )
}
